import React from 'react'
import styles from "./Profile.module.scss"
import { Formik } from 'formik';
import * as Yup from "yup";
import NotificationForm from './NotificationForm';
const initialValues = {
    comments: "",
    annoucements: "",
    email: "",
    alerts: "",
    forms: "",
    taskAssigned: "",
    taskCompleted: "",
    taskDue: "",
    taskOverDue: "",


};
const validationSchema = Yup.object({
    comments: Yup.string().required("Comments is required"),
    annoucements: Yup.string().required("Annoucements is required"),
    alerts: Yup.string().required("alerts is required"),
    forms: Yup.string().required("Forms is required"),
    taskAssigned: Yup.string().required("Tasks is required"),
    taskCompleted: Yup.string().required("Tasks is required"),
})
const Notifications = () => {
    const handleSubmit = async (values, { resetForm }) => {
        console.log(values)
    }
    return (
        <>
            <div className={styles?.mainContainer}>
                <Formik
                    initialValues={initialValues}
                    validateOnChange={false}
                    validateOnBlur={false}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {
                        (formik) => {
                            console.log('formik', formik)
                            return <NotificationForm />
                        }
                    }
                </Formik>
            </div>
        </>
    )
}

export default Notifications

